import { AxiosInstance } from 'axios';
import {
  mapPerspectivesListDtoToModel,
  PerspectiveListDto,
  PerspectivesListModel,
} from 'api/dto/new/Perspectives/PerspectiveListDto';
import {
  mapPerspectiveDtoToModel,
  PerspectiveDto,
  PerspectiveModel,
} from 'api/dto/new/Perspectives/Perspective.dto';
import { RequestPerspectiveDto } from 'api/dto/new/Perspectives/RequestPerspective.dto';
import {
  mapDepartmentsListResultDtoToModel,
  DepartmentsListResultDto,
  DepartmentsListResultModel,
} from 'api/dto/new/Perspectives/DepartmentsListResult.dto';

export class PerspectivesApi {
  constructor(private client: AxiosInstance) {}

  list(surveyId: string): Promise<PerspectivesListModel> {
    return this.client
      .get<PerspectiveListDto>(`/api/survey/${surveyId}/perspectives`)
      .then((response) => mapPerspectivesListDtoToModel(response.data));
  }

  get(surveyId: string, perspectiveId: string): Promise<PerspectiveModel> {
    return this.client
      .get<PerspectiveDto>(`/api/survey/${surveyId}/perspectives/${perspectiveId}`)
      .then((response) => mapPerspectiveDtoToModel(response.data));
  }

  getTopics(): Promise<string[]> {
    return this.client
      .get<{ [p: string]: string }>(`/api/perspectives/topics`)
      .then((response) => Object.values(response.data));
  }

  getDepartments(surveyId: string): Promise<DepartmentsListResultModel> {
    return this.client
      .get<DepartmentsListResultDto>(`/api/survey/${surveyId}/perspectives/departments`)
      .then((response) => mapDepartmentsListResultDtoToModel(response.data));
  }

  request(surveyId: string, requestPerspectiveDto: RequestPerspectiveDto): Promise<string> {
    return this.client
      .post<string>(`/api/survey/${surveyId}/perspectives/request`, requestPerspectiveDto)
      .then((response) => response?.data);
  }
}
